//
//
//
//
//
//
//
//
//
// 参考 https://github.com/HaoChuan9421/vue-ueditor-wrap
import Vue from 'vue';
import VueUeditorWrap from 'vue-ueditor-wrap';
import config from './ueditor.config';
import buttonD2admin from './button/d2admin';
import uploadimg from './button/uploadimg';
Vue.component('VueUeditorWrap', VueUeditorWrap);
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      config: config,
      currentValue: '',
      editorConfig: {
        xssFilterRules: false,
        inputXssFilter: false,
        catchRemoteImageEnable: false,
        section: ['class', 'style'],
        autoHeightEnabled: false,
        initialFrameHeight: 500,
        initialFrameWidth: '100%',
        serverUrl: '/api/ueditor',
        zIndex: 2000,
        toolbars: [['fullscreen', 'source', '|', 'undo', 'redo', '|', 'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|', 'rowspacingtop', 'rowspacingbottom', 'lineheight', '|', 'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|', 'directionalityltr', 'directionalityrtl', 'indent', '|', 'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|', 'link', 'unlink', 'anchor', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|', 'simpleupload', 'insertimage', 'emotion', 'pagebreak', 'template', 'background', '|', 'horizontal', 'date', 'time', 'spechars', 'snapscreen', 'wordimage']]
      }
    };
  },
  watch: {
    // 对外提供 v-model
    value: {
      handler: function handler(val) {
        if (this.currentValue !== val) {
          this.currentValue = val;
        }
      },
      immediate: true
    },
    // 对外提供 v-model
    currentValue: function currentValue(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    init: function init() {
      // 注册一个测试按钮
      // this.$refs.ueditor.registerButton(buttonD2admin)
      this.$refs.ueditor.registerButton(uploadimg);
    }
  }
};